import PromopushkaApiBase from "@/modules/promopushka/services/ApiBase"

export default class ApiBase {
    static shops(query) {
        return PromopushkaApiBase.shopCoupons(query)
    }
}
